<template>
  <div :class="properClass" @click="clickHandler">
    <div class="hamburger-box">
      <div class="hamburger-inner"></div>
    </div>
  </div>
</template>

<script>
import { bus } from "../../main";
export default {
  name: "HamburgerIcon",
  props: {
    isBackgroundPrimary: Boolean,
    isMobileNavOpen: Boolean,
    isContactPanelActive: Boolean,
    screenLevel: String
  },
  methods: {
    clickHandler: function() {
      bus.$emit("mobileNavClickHandler");

      if (this.isMobileNavOpen) {
        bus.$emit("contactPanelHandler", true);
      }
    }
  },
  computed: {
    properClass: function() {
      let output = "hamburger";

      if (!this.isBackgroundPrimary || this.screenLevel === "bottom") {
        output += " hamburger--green";
      }

      if (this.isMobileNavOpen) {
        output += " is-active";
      }

      return output;
    }
  }
};
</script>

<style lang="scss" scoped>
.hamburger {
  margin-top: 7px;
  cursor: pointer;
  transition-timing-function: linear;
  transition-duration: 0.15s;
  transition-property: opacity, filter, background-color;
  background-color: transparent;

  &--green {
    .hamburger-inner {
      background-color: $primary-color;
    }
  }

  &.is-active {
    .hamburger-inner {
      transition-delay: 0.12s;
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      transform: rotate(225deg);

      &::before {
        top: 0;
        transition: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
        opacity: 0;
      }

      &::after {
        bottom: 0;
        transition: bottom 0.1s ease-out,
          transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
        transform: rotate(-90deg);
      }
    }
  }

  &-box {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 24px;
  }

  &-inner {
    position: absolute;
    width: 100%;
    height: 2px;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    transition-duration: 0.22s;
    transition-property: transform;
    border-radius: 2px;
    background-color: #fff;

    top: 50%;
    display: block;
    margin-top: -1px;

    &::before {
      display: block;
      content: "";
      position: absolute;
      width: 100%;
      height: 2px;
      border-radius: 2px;
      background-color: inherit;
      top: -8px;
      transition: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    }

    &::after {
      display: block;
      content: "";
      position: absolute;
      width: 100%;
      height: 2px;
      bottom: -8px;
      transition: bottom 0.1s ease-in 0.25s,
        transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
      border-radius: 2px;
      background-color: inherit;
    }
  }
}
</style>